import classicCircleUrl from '../assets/overlays/classic-circle.svg';
import sunburstRingUrl from '../assets/overlays/sunburst-ring.svg';
import cleanWhiteRingUrl from '../assets/overlays/clean-white-ring.svg';

export const OVERLAYS = [
  {
    id: 'classic-circle',
    labelKey: 'classicCircle',
    url: classicCircleUrl,
  },
  {
    id: 'sunburst-ring',
    labelKey: 'sunburst',
    url: sunburstRingUrl,
  },
  {
    id: 'clean-white-ring',
    labelKey: 'cleanWhite',
    url: cleanWhiteRingUrl,
  },
];
